import { Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
    private dialogService: DialogService;
    constructor(  dialogService: DialogService) {
        this.dialogService = dialogService;
    }

    ngOnInit() {}

    openContactDialog(){
        this.dialogService.openListingRequestDialog();
    }
}
